import { Component, OnInit } from '@angular/core';
declare var jQuery: any;
import '../../../assets/semantic/semantic.min.js';
import { DemandService } from '../../_services/demand.service';

@Component({
  selector: 'app-matching-offers-modal',
  templateUrl: './matching-offers-modal.component.html',
  styleUrls: ['./matching-offers-modal.component.css']
})

export class MatchingOffersModalComponent implements OnInit {
  private demand;
  private history_plannings;
  private offers: object[];
  private pinned_offers: object[];
  private offers_count: number;
  private matching_levels = [false,
    { color: "green", text: "Parfait" },
    { color: "olive", text: "Très bon" },
    { color: "teal", text: "Très Bon (Retour)" },
    { color: "yellow", text: "Moyen" },
    { color: "orange", text: "Mauvais" },
    { color: "orange", text: "Mauvais (Retour)" },
    { color: "red", text: "Très Mauvais" },
    { color: "grey", text: "National" },
    { color: "grey", text: "National (retour)" }];

  constructor(private service: DemandService) { }

  ngOnInit() {

  }

  openModal(demand) {
    this.demand = demand;
    this.refresh();
    jQuery('#demands-mail-confirm-modal').modal({ inverted: true }).modal('hide'); // Hide the Confirmation Modal if it's Open
    jQuery('#matching-offers-modal').modal({ inverted: true, closable: false, allowMultiple: true }).modal('show'); // Then Show the Main Modal
    jQuery('.menu .item').tab();
  }

  openConfirmModal() {
    jQuery('#demands-mail-confirm-modal').modal({ inverted: true }).modal('show');
  }

  refresh() {
    this.service.getPinnedOffers(this.demand.id)
      .subscribe(response => {
        this.pinned_offers = response;

        this.service.getMatchingOffers(this.demand.id) // Get Contacts List
          .subscribe(response => {
            this.offers = response.offers;
            this.offers.forEach(function (offer) { // For Each Offer
              this.pinned_offers.forEach(function (pinned_offer) {
                if (pinned_offer.id === offer.id) { // Watch if it is in the Pinned Ones
                  Object.assign(offer, { pinned: true }); // And set the pinned attribute
                }
              })

            }.bind(this));

            this.offers_count = parseInt(response.total_count);    // Contact Count
          });
      });
    //get planning history from demand details
    this.service.getHistory(this.demand.id)
      .subscribe(response => {
        this.history_plannings = response.plannings;
    });
  }

  pinOffer(offer_id) {
    // Envoyer la Requête
    this.service.pinUnpinOffer({ demand_id: this.demand.id, offer_id: offer_id })
      .subscribe(response => {
        if (response === 200) {
          this.refresh();
        }
      });
  }

  unpinOffer(offer_id) {
    // Envoyer la Requête
    this.service.pinUnpinOffer({ demand_id: this.demand.id, offer_id: offer_id })
      .subscribe(response => {
        if (response === 200) {
          this.refresh();
        }
      });
  }

  sendMail() {
    this.service.sendPinnedOffers(this.demand.id).subscribe();
    jQuery('#demands-mail-confirm-modal').modal({ inverted: true }).modal('hide'); // Hide the Confirmation Modal if it's Open
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/_components/matching-offers-modal/matching-offers-modal.component.ts